import { ComponentType, FC } from 'react'

import {
    GoToMenuItemLinkIcon,
    MenuItemContainer,
    MenuItemContent,
    MenuItemIcon,
    MenuItemText,
} from './menu-item-styles'
import { useTranslation } from '../../../../hooks/locale'

interface Props {
    icon: ComponentType
    altText: string
    title: string
    link: string
}

const MenuItem: FC<Props> = ({ icon, altText, title, link }) => {
    const { t } = useTranslation()

    return (
        <MenuItemContainer>
            <MenuItemContent href={link}>
                <MenuItemIcon as={icon as any} aria-label={altText} />
                <MenuItemText>{title}</MenuItemText>
                <GoToMenuItemLinkIcon aria-label={t('goToMenuItemLinkIcon')} />
            </MenuItemContent>
        </MenuItemContainer>
    )
}

export default MenuItem
